import React from 'react'
import { Provider } from './Context'
import { Layout } from './Layout'

export const AddTask = ({ ...rest }) => {
  return (
    <Provider {...rest}>
      <Layout />
    </Provider>
  )
}
